<md-icon class="!flex !text-lg/5 w-7 h-full items-center" [modusMenuTriggerFor]="menu"
  >more_vertical</md-icon
>

<md-menu #menu>
  <md-menu-item (itemClick)="onModelDetailClick()">{{
    translations.showDetails.text
  }}</md-menu-item>
  <md-menu-item
    data-cy="3d-fit-to-view"
    [disabled]="fitToViewDisabled()"
    (itemClick)="onModelFitToViewClick()"
  >
    {{ translations.fitToView.text }}
  </md-menu-item>

  @if (hasViewInNumarkFeature()) {
    <md-menu-item (itemClick)="onViewInNumarkClick()">
      <div class="flex items-center">
        {{ translations.viewInNumark.text }}
      </div>
    </md-menu-item>
  }

  @if (hasRotatePanoramasFeature()) {
    <md-menu-item (itemClick)="onRotatePanoramasClick()" [disabled]="rotatePanoramasDisabled()">
      <div class="flex items-center">
        {{ translations.rotatePanoramas.text }} ({{ panoramaHeadingOffset() }})
      </div>
    </md-menu-item>
  }
</md-menu>
